import { Typography, Box } from "@mui/material";
import { NavigationLink } from "./Header";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

type NavLinksProps = {
  toggleDrawer?: () => void;
};

const NavLinks = ({ toggleDrawer }: NavLinksProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        paddingRight={"2rem"}
        paddingBottom={isMobile ? "1rem" : 0}
        paddingTop={isMobile ? "1rem" : 0}
      >
        <NavigationLink to={"/zoeken/"} onClick={toggleDrawer}>
          <Typography fontSize={isMobile ? 20 : 14} letterSpacing={"0.5px"}>
            {t("nav.property_listing")}
          </Typography>
        </NavigationLink>
      </Box>
      <Box
        paddingRight={"2rem"}
        paddingBottom={isMobile ? "1rem" : 0}
        paddingTop={isMobile ? "1rem" : 0}
      >
        <NavigationLink
          as="a"
          href={"https://gohome.rent/woning-huren/"}
          onClick={toggleDrawer}
        >
          <Typography fontSize={isMobile ? 20 : 14} letterSpacing={"0.5px"}>
            {t("nav.rent")}
          </Typography>
        </NavigationLink>
      </Box>
      <Box
        paddingRight={"2rem"}
        paddingBottom={isMobile ? "1rem" : 0}
        paddingTop={isMobile ? "1rem" : 0}
      >
        <NavigationLink
          as="a"
          href={"https://gohome.rent/woning-verhuren/"}
          onClick={toggleDrawer}
        >
          <Typography fontSize={isMobile ? 20 : 14} letterSpacing={"0.5px"}>
            {t("nav.rent_out")}
          </Typography>
        </NavigationLink>
      </Box>
    </>
  );
};

export default NavLinks;
